import {useEffect, useMemo} from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from "../../app/store/hooks.ts";
import { selectInProgressGenerations } from "../../app/store/selectors/inProgressSelector.ts";
import { GenerationApi } from "../api/generationApi.ts";
import { updateGenerations } from "../../app/store/slices/userSlice.ts";
import { GenerationStatusEnum } from '../../shared/types/GenerationStatusEnum.ts';


export const useGenerationPolling = () => {
    const generationService = useMemo(() => new GenerationApi(), [])
    const inProgress = useSelector(selectInProgressGenerations);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!inProgress.length) return;

        const checkStatus = async () => {
            const updatedGenerations = await generationService.getGenerationsStatus(inProgress);
            const generationsWithFinalStatus = updatedGenerations
                .filter(generation => generation.status !== GenerationStatusEnum.PROCESSING)
            if (generationsWithFinalStatus.length > 0) {
                dispatch(updateGenerations(generationsWithFinalStatus));
            }
        };

        const intervalId = setInterval(checkStatus, 5000);

        return () => {
            clearInterval(intervalId);
        };
    }, [inProgress, dispatch]);
};
